import React, {Component} from 'react';
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row,} from "reactstrap";

export default class CommonConfirmationModal extends Component {

    render() {
        const awaitStyle = {
            awaitHead: {
                //height: "24px",
                //width: "196px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "24px",
                textAlign: "center",
            },
            awaitBody: {
                //height: "34px",
                //width: "312px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                letterSpacing: "0",
                lineHeight: "17px",
                textAlign: "center",
                padding: "0% 9%",
            },
            okButton: {
                //height: "40px",
                //width: "136px",
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
            },
            okButtonText: {
                //height: "19px",
                //width: "20px",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            cancelButtonText: {
                //height: 19px,
                //width: 54px,
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            requestButtonText: {
                //height: 19px,
                //width: 62px,
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
        };
        return (
            <Modal isOpen={this.props.commonConfirmationFlag} toggle={() => this.props.closeModal()} centered>
                <ModalHeader className="border-0 justify-content-center">
                    {this.props.image && <img
                        src={this.props.image}
                        className="rounded img-fluid"
                        alt=""
                        width="50"
                        height="50"
                    />}
                </ModalHeader>
                <ModalBody className="justify-content-center">
                    {this.props.title && <h4 className="text-center mb-2" style={awaitStyle.awaitHead}>
                        {this.props.title}
                    </h4>}
                    {this.props.content && <p className="text-center" style={awaitStyle.awaitBody}>
                        {this.props.content}
                    </p>}
                </ModalBody>
                <ModalFooter className="border-0 justify-content-center">
                    <Row className="mx-5">
                        <Col>
                            <Button
                                outline
                                color="primary"
                                className="px-5"
                                onClick={() => this.props.closeModal()}
                            >
                                <span style={awaitStyle.cancelButtonText}>{this.props.cancelButtonText}</span>
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                color="primary"
                                className="px-5 text-capitalize"
                                onClick={() => this.props.confirmFunction()}
                            >
                                <span style={awaitStyle.requestButtonText}>{this.props.okayButtonText}</span>
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        );
    }
}